import * as React from 'react'
import styled from '@theme/styled-components'

import { View } from 'react-native'
import SVG from 'react-inlinesvg'

interface Props {
  name: IconName
  color?: string
  size?: number
  height?: number
}

const icons: { [key in IconName]: string } = {
  add: require('./svg/add.svg'),
  'add-circle': require('./svg/add-circle.svg'),
  apartment: require('./svg/apartment.svg'),
  arrow: require('./svg/arrow.svg'),
  'arrow-down': require('./svg/arrow-down.svg'),
  'arrow-left': require('./svg/arrow-left.svg'),
  'arrow-up': require('./svg/arrow-up.svg'),
  'long-arrow-left': require('./svg/long-arrow-left.svg'),
  badge: require('./svg/badge.svg'),
  batiment: require('./svg/batiment.svg'),
  calendar: require('./svg/calendar.svg'),
  cancel: require('./svg/cancel.svg'),
  charpenter: require('./svg/charpenter.svg'),
  check: require('./svg/check.svg'),
  checkbox_checked: require('./svg/checkbox_checked.svg'),
  checkbox_unchecked: require('./svg/checkbox_unchecked.svg'),
  checkbox_partial: require('./svg/checkbox_partial.svg'),
  checked: require('./svg/checked.svg'),
  'check-list': require('./svg/check-list.svg'),
  clean: require('./svg/clean.svg'),
  close: require('./svg/close.svg'),
  comment: require('./svg/comment.svg'),
  connectivity: require('./svg/connectivity.svg'),
  delete: require('./svg/delete.svg'),
  'divers-work': require('./svg/divers-work.svg'),
  document: require('./svg/document.svg'),
  done: require('./svg/done.svg'),
  dot: require('./svg/dot.svg'),
  download: require('./svg/download.svg'),
  edit: require('./svg/edit.svg'),
  electric: require('./svg/electric.svg'),
  elevator: require('./svg/elevator.svg'),
  email: require('./svg/email.svg'),
  fav: require('./svg/fav.svg'),
  filter: require('./svg/filter.svg'),
  folder: require('./svg/folder.svg'),
  'full-arrow': require('./svg/full-arrow.svg'),
  gps: require('./svg/gps.svg'),
  hammer: require('./svg/hammer.svg'),
  image: require('./svg/image.svg'),
  incident_clock: require('./svg/incident_clock.svg'),
  incident_done: require('./svg/incident_done.svg'),
  incident_euro: require('./svg/incident_euro.svg'),
  incident_key: require('./svg/incident_key.svg'),
  incident_minus: require('./svg/incident_minus.svg'),
  'incident_right-arrow': require('./svg/incident_right-arrow.svg'),
  incident_pause: require('./svg/incident_pause.svg'),
  incident_cross: require('./svg/incident_cross.svg'),
  info: require('./svg/info.svg'),
  key: require('./svg/key.svg'),
  location: require('./svg/location.svg'),
  'love-filled': require('./svg/love-filled.svg'),
  mail: require('./svg/mail.svg'),
  map: require('./svg/map.svg'),
  menu: require('./svg/menu.svg'),
  mobile: require('./svg/mobile.svg'),
  painting: require('./svg/painting.svg'),
  phone: require('./svg/phone.svg'),
  photo: require('./svg/photo.svg'),
  prestataire: require('./svg/prestataire.svg'),
  problem: require('./svg/problem.svg'),
  profil: require('./svg/profil.svg'),
  radio_empty: require('./svg/radio_empty.svg'),
  radio_filled: require('./svg/radio_filled.svg'),
  redo: require('./svg/redo.svg'),
  search: require('./svg/search.svg'),
  send: require('./svg/send.svg'),
  settings: require('./svg/settings.svg'),
  'sms-failed': require('./svg/sms-failed.svg'),
  sync: require('./svg/sync.svg'),
  tab_checklist: require('./svg/tab_checklist.svg'),
  tab_edl: require('./svg/tab_edl.svg'),
  tab_profile: require('./svg/tab_profile.svg'),
  tab_quality: require('./svg/tab_quality.svg'),
  timer: require('./svg/timer.svg'),
  undo: require('./svg/undo.svg'),
  unvisibility: require('./svg/unvisibility.svg'),
  upload: require('./svg/upload.svg'),
  verified: require('./svg/verified.svg'),
  viparis: require('./svg/viparis.svg'),
  visibility: require('./svg/visibility.svg'),
  water: require('./svg/water.svg'),
  window: require('./svg/window.svg'),
}

const Icon = ({ name, size = 20, color, height }: Props) => {
  const iconSrc = icons[name || 'heart']

  return (
    <IconContainer size={size} color={color}>
      <SVG
        src={iconSrc}
        preProcessor={(code) =>
          code
            .replace(/ width=".*?"/g, ` width="${size}"`)
            .replace(/height=".*?"/g, `height="${height ? height : size}"`)
        }
      />
    </IconContainer>
  )
}

export default Icon

const IconContainer = styled(View)<{ size: number; color?: string }>`
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  ${(props) => !!props.color && `color: ${props.color};`}
`
